import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a',
  'b',
  'br',
  'div',
  'em',
  'i',
  'li',
  'ol',
  'p',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'u',
  'ul'
];

const ALLOWED_ATTR = [
  'border',
  'cellpadding',
  'cellspacing',
  'class',
  'colspan',
  'href',
  'rel',
  'rowspan',
  'style',
  'target',
  'width'
];

let hooksReady = false;

function ensureHooks() {
  if (hooksReady) return;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  hooksReady = true;
}

export function sanitizeHtml(html?: string | null): string {
  ensureHooks();
  return DOMPurify.sanitize(html || '', {
    ALLOWED_TAGS,
    ALLOWED_ATTR
  });
}

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function emphasizeMatch(match: string): string {
  return `<b>${escapeHtml(match)}</b>`;
}

const SAFE_URL = /^(https?:|mailto:|\/(?!\/))/i;

export function sanitizeUrl(url?: string | null): string {
  if (!url) return '';
  const trimmed = url.trim();
  return SAFE_URL.test(trimmed) ? trimmed : '';
}
